<template>
  <form
    id="signin"
    name="signInForm"
    class="px-3"
    v-on:submit.prevent="signIn">
    <h4 class="text-secondary">
      Please sign in
      <hr class="mt-2 mb-0">
    </h4>

    <!-- Username -->
    <label for="username">Username:</label>
    <b-form-input
      id="username"
      type="text"
      name="username"
      placeholder="Enter your username"
      v-model="credentials.username"
    />
    <!-- / Username -->

    <!-- Password -->
    <label class="mt-3" for="password">Password:</label>
    <b-form-input
      id="password"
      type="password"
      name="password"
      placeholder="Enter your password"
      v-model="credentials.password"
    />
    <!-- / Password -->

    <!-- Submit -->
    <b-button
      class="mt-3"
      type="submit"
      variant="success"
      :disabled="submitting">
      Sign In
    </b-button>
    <!-- / Submit -->
  </form>
</template>

<script>
import _ from 'lodash';
import DataSvc from '../services/data';
import Session from '../services/user-session';
import AppMixin from '../services/app-mixin';
import BrowserStorageMixin from '../services/browser-storage-mixin';

export default {
  name: 'signin',
  mixins: [
    AppMixin,
    BrowserStorageMixin,
  ],
  data() {
    return {
      submitting: false,
      credentials: {
        username: process.env.VUE_APP_USERNAME,
        password: process.env.VUE_APP_PASSWORD,
      },
    };
  },
  methods: {
    signIn() {
      this.showGlobalLoader('Authorizing...');
      this.submitting = true;

      return DataSvc.signIn(this.credentials)
        .then(Session.begin)
        .then((data) => {
          [this.loggedInUser, this.organizations] = data;

          // if acting org not already set
          // set acting org as first returned org
          if (!this.loggedInUser.actingOrg) {
            [this.loggedInUser.actingOrg] = _.cloneDeep(this.organizations);
          }

          this.loggedInUser.actingSeason = { name: 'All Seasons' };

          const referrer = this.sessionStorageGet('referrer', { name: 'events' });
          this.$router.replace(referrer);

          Session.update(this.loggedInUser);

          return DataSvc.getSeasons(this.loggedInUser.actingOrg.id);
        })
        .then((seasons) => {
          this.seasons = seasons;
        })
        .finally(() => {
          this.hideGlobalLoader();
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss">
#signin {
  max-width: 350px;
  margin: auto;
  margin-top: 10vh;
}
</style>
